import useIsMobile from "../hooks/useIsMobile";

function fmtDateDMY(isoVal) {
  if (!isoVal) return "";
  const [y, m, d] = isoVal.split("-");
  return `${d}/${m}/${y}`;
}

const inputStyle = (error) => ({
  width: "100%",
  padding: "12px 16px",
  border: `2px solid ${error ? "#e53e3e" : "#e8e0d4"}`,
  borderRadius: "10px",
  fontSize: "15px",
  fontFamily: "'DM Sans', sans-serif",
  backgroundColor: error ? "#fff5f5" : "#fdfbf7",
  color: "#2d2418",
  transition: "all 0.2s ease",
  outline: "none",
  boxSizing: "border-box",
});

const focusHandler = (error) => (e) => {
  e.target.style.borderColor = error ? "#e53e3e" : "#c45d3e";
  e.target.style.backgroundColor = "#fff";
  e.target.style.boxShadow = `0 0 0 3px ${error ? "rgba(229, 62, 62, 0.1)" : "rgba(196, 93, 62, 0.1)"}`;
};

const blurHandler = (error) => (e) => {
  e.target.style.borderColor = error ? "#e53e3e" : "#e8e0d4";
  e.target.style.backgroundColor = error ? "#fff5f5" : "#fdfbf7";
  e.target.style.boxShadow = "none";
};

export default function InputField({ label, value, onChange, placeholder, type = "text", required = false, half = false, error = "", min, max, step, helperText = "" }) {
  const isMobile = useIsMobile();
  const isDate = type === "date";

  return (
    <div style={{ flex: half ? "1 1 48%" : "1 1 100%", minWidth: half ? (isMobile ? 0 : "220px") : "auto" }}>
      <label
        style={{
          display: "block",
          fontSize: "13px",
          fontWeight: 600,
          color: "#4a3f35",
          marginBottom: "6px",
          fontFamily: "'DM Sans', sans-serif",
          letterSpacing: "0.02em",
        }}
      >
        {label}
        {required && <span style={{ color: "#c45d3e" }}> *</span>}
      </label>
      {isDate ? (
        <div style={{ position: "relative" }}>
          <input
            type="date"
            value={value}
            onChange={onChange}
            style={{
              ...inputStyle(error),
              color: "transparent",
              WebkitTextFillColor: "transparent",
            }}
            onFocus={(e) => {
              focusHandler(error)(e);
              e.target.style.color = "transparent";
              e.target.style.WebkitTextFillColor = "transparent";
            }}
            onBlur={(e) => {
              blurHandler(error)(e);
              e.target.style.color = "transparent";
              e.target.style.WebkitTextFillColor = "transparent";
            }}
          />
          <span
            style={{
              position: "absolute",
              left: "16px",
              top: "50%",
              transform: "translateY(-50%)",
              pointerEvents: "none",
              fontSize: "15px",
              fontFamily: "'DM Sans', sans-serif",
              color: value ? "#2d2418" : "#b8a890",
            }}
          >
            {value ? fmtDateDMY(value) : "zz/ll/aaaa"}
          </span>
        </div>
      ) : (
        <input
          type={type}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          style={inputStyle(error)}
          onFocus={focusHandler(error)}
          onBlur={blurHandler(error)}
          min={min}
          max={max}
          step={step}
        />
      )}
      {error && (
        <p style={{
          fontSize: "12px",
          color: "#e53e3e",
          margin: "4px 0 0 0",
          fontFamily: "'DM Sans', sans-serif",
        }}>
          {error}
        </p>
      )}
      {helperText && !error && (
        <p style={{
          fontSize: "12px",
          color: "#b8a890",
          margin: "4px 0 0 0",
          fontFamily: "'DM Sans', sans-serif",
        }}>
          {helperText}
        </p>
      )}
    </div>
  );
}
